import { Button, ColorPicker, Form, Input, message, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { serverFetch } from "@/server";

const CardVid = ({ id, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      form.setFieldsValue({ name: "", colorCode: "#CCCCCC" });
      return;
    }

    setLoading(true);
    serverFetch(`Card/vid/${id}`)
      .then(data => {
        form.setFieldsValue(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }, [id, form]);

  const onSave = () => {
    form.validateFields().then(values => {
      const colorValue = values.colorCode;
      const colorCode = typeof colorValue === "string"
        ? colorValue
        : colorValue?.toHexString?.();
      const bodyData = {
        ...values,
        id: id ?? 0,
        name: values.name.trim(),
        colorCode,
      };

      setLoading(true);
      serverFetch("Card/vid", { method: id ? "PUT" : "POST", bodyData })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" style={{ width: 480 }} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>{id ? "Группа карт" : "Новая группа карт"}</span>
          <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
        </div>
        <Form form={form} labelCol={{ span: 7 }} wrapperCol={{ span: 17 }} colon={false} disabled={loading}>
          <Form.Item name="name" label="Название" rules={[{ required: true, message: "Введите название" }]}>
            <Input maxLength={120} />
          </Form.Item>
          <Form.Item
            name="colorCode"
            label="Цвет"
            rules={[{ required: true, message: "Укажите цвет" }]}
            getValueFromEvent={color => color?.toHexString?.() ?? color}
            getValueProps={value => ({ value: value || "#CCCCCC" })}
          >
            <ColorPicker format="hex" showText style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label=" ">
            <Space>
              <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
              <Button onClick={() => onClose(false)}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>;
};

export default CardVid;
